import { Component } from '@angular/core';
import { NavParams } from 'ionic-angular';
import { LoaddingService } from '../../providers/loadding.service';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
    selector: 'promotiondetail',
    templateUrl: 'promotiondetail.html'
})
export class PromotionDetail {

    article;
    constructor(
        private loadding: LoaddingService,
        private navPar: NavParams,
        private sanitizer: DomSanitizer
    ) { }

    ionViewDidLoad() {
        this.getDetail();
    }



    //查看公告详情
    //TQQ 2017-01-19
    getDetail() {
        this.article = this.sanitizer.bypassSecurityTrustHtml(this.navPar.get("summary"));
    }
}



// WEBPACK FOOTER //
// ./src/pages/promotion/promotiondetail.ts